<template>
  <div class="questionnaire-container">
    <!-- 加载页面 -->
    <div class="question-empty">
      <div class="question-bottom">
        <!-- Lottie动画容器 -->
        <div class="question-icon" ref="lottieContainer"></div>
        <div class="question-title">
          根据您的身体状况
        </div>
        <div class="question-tip">正在为您构建专属的每日营养补充方案</div>
      </div>
    </div>
  </div>
</template>

<script>
import lottie from 'lottie-web'
import radar from '@/assets/lottie/radar.json'

export default {
  name: "CustomSolutionLoader",

  data() {
    return {
      anim: null
    }
  },

  mounted() {
    this.initLottieAnimation();
    this.startLoadingProcess();
  },

  beforeDestroy() {
    if (this.anim) {
      this.anim.destroy();
      this.anim = null;
    }
  },

  methods: {
    // 初始化Lottie动画
    initLottieAnimation() {
      this.anim = lottie.loadAnimation({
        container: this.$refs.lottieContainer,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: radar
      });
    },

    // 开始加载过程
    startLoadingProcess() {
      // 3秒后触发完成事件
      setTimeout(() => {
        this.$emit('loading-complete');
      }, 3000);
    }
  }
}
</script>

<style scoped lang="scss">
.questionnaire-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  z-index: 9999;
}

.question-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  transform: translateY(-60px);
}

.question-bottom {
  text-align: center;
  color: #333333;
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.question-icon {
  width: 160px;
  height: 160px;
  margin: 0 auto 20px;
}

.question-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  line-height: 1.4;
  color: #333333;
  text-align: center;
}

.question-tip {
  font-size: 16px;
  opacity: 0.8;
  margin-bottom: 40px;
  color: #666666;
  white-space: nowrap;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}



/* 响应式设计 */
@media (max-width: 480px) {
  .question-icon {
    width: 140px;
    height: 140px;
    margin-bottom: 20px;
  }

  .question-title {
    font-size: 16px;
    text-align: center;
  }

  .question-tip {
    font-size: 16px;
    white-space: nowrap;
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>